import {doc} from './docs.js';
import {isNumber} from "utils/IsNumber.js"

doc(
    "select",
    {
        args: "args"
    },
    "Matches messages by arguments and sends them to the respective output",
    (x) => x,
    {
        tags: "Messages"
    }
);


export const select = (object, ...args) => {
    return (msg) => {
        for (let i=0; i < args.length; i++) {
            let arg = args[i]();
            if (eq(arg, msg[0])) {
                let x = new Array(args.length).fill(undefined);
                x[i] = msg;
                return x;
            }
        }
        return undefined;
    };
};

doc(
    "between",
    {
        args: "args"
    },
    "Matches messages by arguments and sends them to the respective output",
    (x) => x+1,
    {
        tags: "Messages"
    }
);


export const between = (object, ...args) => {
    return ([msg]) => {
        if (msg < args[0]()) {
            let x = new Array(args.length).fill(undefined);
            x[0] = msg;
            return x;
        }
        let len = args.filter(x => x()).length;
        for (let i=0; i < len - 1; i++) {
            let arg1 = args[i]();
            let arg2 = args[i+1]();
            if (arg1 <= msg && msg < arg2) {
                let x = new Array(args.length).fill(undefined);
                x[i+1] = msg;
                return x;
            }
        }

        if (msg >= args[len-1]()) {
            let x = new Array(args.length).fill(undefined);
            x[len] = msg;
            return x;
        }

        return undefined;
    };
};


doc(
    "nameIndex",
    {
        args: "args"
    },
    "");
export const nameIndex = (object, ...args) => {
    return ([msg]) => {
        return args.map(x => x()).indexOf(msg);
    };
};

const eq = (a,b) => {
    try {
        return parseFloat(a) === parseFloat(b);
    } catch (e) {
        return a===b;
    }
};
